import { LoginContext } from "helpers/LoginContext";
import SideBar from "components/common/SideBar/SideBarNew";
import React, { useCallback, useContext, useEffect, useState } from "react";
import Header from "components/common/Header/Header";
import CustomButton from "components/common/Button/CustomButton";
import { BiExit } from "react-icons/bi";
import { useNavigate } from "react-router";
import Breadcrumb from "components/common/Breadcrumb";
import {
  ROSTERING_BREADCRUMB,
  ROSTERING_BREADCRUMB_PAGES,
} from "Constants/BreadcrumbConstant";
import TimesheetDetails from "./TimeSheetDetailsSection";
import { useSelector } from "react-redux";
import {
  getSingleSelectedTimesheetWorkerDetails,
  getTimesheetsofWorkersLoader,
} from "store/selector/rostering.selector";
import useCareLabels from "hooks/useCareLabels";
import { resetSidebarFetchState } from "./TimeSheetSidebar";
import { buildAllParticipantsOption } from "./utils/timesheetParticipantFilter";

const TimeSheet = ({
  spParticipants,
  getParticipantList,
  getTimesheetsofWorkers,
  timeSheetsListOfWorkers,
  selectedTimesheetDateRange,
  resetDateRange,
  resetUpdatedTimesheetPage,
  spRosteringSetting,
  spRosteringSettingsRequest,
  spRosteringSettingLoader,
}) => {
  const { sideBarPadding } = useContext(LoginContext);
  const { participantLabelPlural } = useCareLabels();

  const singleSelectedWorkerTimesheets = useSelector(
    getSingleSelectedTimesheetWorkerDetails
  );
  const workersLoader = useSelector(getTimesheetsofWorkersLoader);
  const [selectedWorkerInSidebar, setSelectedWorkerInSidebar] = useState(null);
  const [selectedParticipants, setSelectedParticipants] = useState(() => [
    buildAllParticipantsOption(participantLabelPlural),
  ]);
  const [checkboxes, setCheckboxes] = useState([]);
  const [page, setPage] = useState(1);
  const [sidebarLoadedCount, setSidebarLoadedCount] = useState(0);

  const clearTimesheetPageState = useCallback(() => {
    resetUpdatedTimesheetPage();
    resetDateRange();
    resetSidebarFetchState();
  }, [resetDateRange, resetUpdatedTimesheetPage]);

  useEffect(() => {
    return () => {
      clearTimesheetPageState();
    };
  }, [clearTimesheetPageState]);

  useEffect(() => {
    spRosteringSettingsRequest();
  }, [spRosteringSettingsRequest]);

  const navigate = useNavigate();

  return (
    <main className="min-h-full bg-[#F6F7F8]">
      <SideBar />
      <div
        className={`duration-300 flex flex-col ${
          sideBarPadding ? "lg:pl-[4rem]" : "lg:pl-64"
        }`}
      >
        <Header
          btnComponent={
            <CustomButton
              label="Back to Schedule"
              Icon={<BiExit />}
              clickHandler={() => navigate("/rostering/schedule")}
              cssClass="!rounded-[10px] !border-[#D8DCE3] !bg-white !text-white !shadow-none"
            />
          }
          breadcrumb={
            <Breadcrumb
              pages={ROSTERING_BREADCRUMB(ROSTERING_BREADCRUMB_PAGES.TIMESHEET)}
            />
          }
        />
        <section className="min-w-0 overflow-x-hidden px-3 pt-4 pb-6 sm:px-4">
          <TimesheetDetails
            selectedTimesheetDateRange={selectedTimesheetDateRange}
            resetDateRange={resetDateRange}
            singleSelectedWorkerTimesheets={singleSelectedWorkerTimesheets}
            selectedWorkerInSidebar={selectedWorkerInSidebar}
            spRosteringSetting={spRosteringSetting}
            spRosteringSettingLoader={spRosteringSettingLoader}
            page={page}
            setPage={setPage}
            sidebarLoadedCount={sidebarLoadedCount}
            selectedParticipants={selectedParticipants}
            setSelectedParticipants={setSelectedParticipants}
            setCheckboxes={setCheckboxes}
            checkboxes={checkboxes}
            participantList={spParticipants}
            getParticipantList={getParticipantList}
            getTimesheetsofWorkers={getTimesheetsofWorkers}
            timeSheetsListOfWorkers={timeSheetsListOfWorkers}
            setSelectedWorkerInSidebar={setSelectedWorkerInSidebar}
            workersLoader={workersLoader}
            onSidebarLoadedCountChange={setSidebarLoadedCount}
          />
        </section>
      </div>
    </main>
  );
};

export default TimeSheet;
